import { authApi } from '../utils/api';

export const dashboardPage = () => {
    const user = authApi.getCurrentUser();

    if (!user) {
        return `
            <section class="page-content">
                <div class="container">
                    <div class="alert alert-warning">
                        <p>Bu sayfayı görüntülemek için giriş yapmanız gerekiyor.</p>
                        <a href="/giris" class="btn-primary">Giriş Yap</a>
                    </div>
                </div>
            </section>
        `;
    }

    return `
        <section class="page-content dashboard-page">
            <div class="container">
                <div class="dashboard-header">
                    <h1>Hoş Geldiniz, ${user.ad} ${user.soyad}</h1>
                    <p>Hesabınızı ve poliçelerinizi buradan yönetebilirsiniz.</p>
                </div>

                <div class="dashboard-grid">
                    <div class="dashboard-card">
                        <div class="card-icon">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                                <circle cx="12" cy="7" r="4"></circle>
                            </svg>
                        </div>
                        <h3>Profil Bilgileri</h3>
                        <p>Ad: ${user.ad} ${user.soyad}</p>
                        <p>Email: ${user.email}</p>
                        <p>Telefon: ${user.telefon || '-'}</p>
                    </div>

                    <a href="/ruhsatlarim" class="dashboard-card clickable">
                        <div class="card-icon">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <rect x="3" y="4" width="18" height="16" rx="2"></rect>
                                <path d="M7 8h10M7 12h6"></path>
                            </svg>
                        </div>
                        <h3>Ruhsatlarım</h3>
                        <p>Kayıtlı araç ruhsatlarınızı görüntüleyin</p>
                    </a>

                    <a href="/policelerim" class="dashboard-card clickable">
                        <div class="card-icon">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
                            </svg>
                        </div>
                        <h3>Poliçelerim</h3>
                        <p>Sigorta poliçelerinizi görüntüleyin</p>
                    </a>

                    ${user.rol === 'admin' ? `
                        <a href="/admin" class="dashboard-card clickable admin-card">
                            <div class="card-icon">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                    <circle cx="12" cy="12" r="3"></circle>
                                    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path>
                                </svg>
                            </div>
                            <h3>Admin Paneli</h3>
                            <p>Sistem yönetimi</p>
                        </a>
                    ` : ''}
                </div>
            </div>
        </section>
    `;
};
